/*
 * @Author: edvardchen
 * @Date:   2016-10-23 16:35:27
 * @Last Modified by: zloongjiang
 * @Last Modified time: 2019-05-10 16:05:21
 */

import React from 'react';
import PropTypes from 'prop-types';

import Article from './ArticleForShare';
import Video from './Video';
import UgcVideo from './UgcVideo';
import FloatVideo from './FloatVideo';

if (__CLIENT__) {
  require('./index.scss');
}

export default function Media(props) {
  const { type } = props;

  switch (type) {
    case 'article':
      return <Article {...props} />;
    case 'video': {
      if (!props.vid) {
        const { image, ...rest } = props;
        return <Article {...{ ...rest, thumbs: [image] }} skip={1} />;
      }
      return <Video {...props} id={props.vid} onPlay={props.onClick} />;
    }
    case 'ugc_video':
      return <UgcVideo {...props}></UgcVideo>;
    case 'float_video':
      return <FloatVideo {...props}></FloatVideo>;
    default:
      return null;
  }
}

Media.propTypes = {
  type: PropTypes.string,
  vid: PropTypes.string,
  image: PropTypes.string,
  onClick: PropTypes.func,
};
